/* ============================================================
   Sougou Express — Fiches produits
   Replie les sections de la description produit en accordéons
   cliquables, au même format que « Conservation & fraîcheur »
   et « Origine & qualité ».
   Sections concernées :
     • Origine & valeur ajoutée
     • Usages & astuces
     • Évocation sensorielle & projection (émotionnelle)
   ============================================================ */
(function () {
  var CARET =
    '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';

  var ICON_PLANT =
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-plant" viewBox="0 0 20 20"><path d="M15.963 5.166a.5.5 0 0 1 .09.701L11.232 12.1a3.5 3.5 0 0 0-.732 2.142v3.486a.5.5 0 0 1-1 0v-3.487a4.5 4.5 0 0 1 .94-2.753l4.822-6.233a.5.5 0 0 1 .701-.09"/><path d="M4.137 9.11a.5.5 0 0 0 .018.707l4.256 4.044A3.5 3.5 0 0 1 9.5 16.398V19.5a.5.5 0 0 0 1 0v-3.102a4.5 4.5 0 0 0-1.4-3.262L4.842 9.092a.5.5 0 0 0-.706.018"/><path fill-rule="evenodd" d="M18.378 1.54c.055.75.095 1.787.027 2.867-.093 1.467-.375 2.85-.95 3.739-.738 1.138-1.767 1.754-2.744 2-1.02.256-1.864.087-2.251-.164-.845-.547-1.794-2.72-.296-5.032.553-.854 1.786-1.654 3.244-2.316a24 24 0 0 1 2.97-1.095M18.73.4a.465.465 0 0 1 .588.406c.15 1.485.417 5.659-1.024 7.883-1.774 2.738-5.004 3.023-6.378 2.132-1.375-.89-2.345-3.708-.591-6.415C12.767 2.181 17.2.814 18.73.4M1.162 6.236c.087.567.223 1.278.43 1.993.306 1.058.726 1.977 1.25 2.5.706.706 1.537.989 2.272 1.015.779.028 1.329-.229 1.528-.428.457-.457.853-2.13-.595-3.578-.496-.496-1.464-.888-2.639-1.155a18 18 0 0 0-2.246-.347M.57 5.188a.46.46 0 0 0-.49.517c.147 1.245.64 4.316 2.055 5.731 1.8 1.8 4.31 1.49 5.215.587.903-.904 1.184-3.212-.595-4.992C5.335 5.613 1.903 5.27.57 5.188"/></svg>';

  var ICON_DISH =
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-serving-dish" viewBox="0 0 20 20"><path d="M10 7.229c-4.164 0-7.558 3.453-7.558 7.736a.5.5 0 0 1-1 0c0-4.815 3.821-8.736 8.558-8.736s8.558 3.921 8.558 8.736a.5.5 0 0 1-1 0c0-4.283-3.394-7.736-7.558-7.736"/><path d="M.473 14.987a.5.5 0 0 1 .5-.5h18.054a.5.5 0 1 1 0 1H.973a.5.5 0 0 1-.5-.5m5.62-5.085a.25.25 0 0 1-.119.333c-.46.219-1.449 1.029-1.54 2.459a.25.25 0 1 1-.5-.032c.107-1.658 1.247-2.604 1.826-2.879a.25.25 0 0 1 .333.12"/><path fill-rule="evenodd" d="M10.49 5.048h-.98a1 1 0 0 0-1 1v.147h2.98v-.147a1 1 0 0 0-1-1m-.98-1a2 2 0 0 0-2 2v1.147h4.98V6.048a2 2 0 0 0-2-2z"/></svg>';

  var ICON_STAR =
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-star" viewBox="0 0 20 20"><path fill-rule="evenodd" d="m10 2.626-1.46 4.71c-.192.62-.743 1.041-1.365 1.041H2.453l3.82 2.91a1.55 1.55 0 0 1 .522 1.685l-1.46 4.71 3.821-2.911a1.38 1.38 0 0 1 1.688 0l3.82 2.91-1.459-4.71c-.192-.62.019-1.3.522-1.683l3.82-2.911h-4.722c-.622 0-1.173-.42-1.366-1.04zm.455-1.78a.472.472 0 0 0-.91 0L7.63 7.027a.48.48 0 0 1-.455.347H.98c-.464 0-.657.622-.282.908l5.012 3.82a.52.52 0 0 1 .174.56l-1.914 6.18c-.143.462.361.847.736.56l5.013-3.818a.46.46 0 0 1 .562 0l5.013 3.819c.375.286.88-.099.736-.561l-1.914-6.18a.52.52 0 0 1 .174-.56l5.012-3.82c.375-.286.182-.908-.282-.908h-6.195a.48.48 0 0 1-.455-.347z"/></svg>';

  /* Titres à replier — préfixes normalisés (sans accents, minuscules) */
  var TARGETS = [
    { prefix: 'origine & valeur ajoutee', icon: ICON_PLANT },
    { prefix: 'usages & astuces', icon: ICON_DISH },
    { prefix: 'evocation sensorielle & projection', icon: ICON_STAR }
  ];

  function norm(s) {
    return (s || '')
      .replace(/\u00a0/g, ' ')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&amp;/gi, '&')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isHeading(el) {
    return el && el.nodeType === 1 && /^H[1-6]$/.test(el.tagName);
  }

  function matchTarget(el) {
    if (!isHeading(el)) return null;
    var t = norm(el.textContent);
    for (var i = 0; i < TARGETS.length; i++) {
      if (t.indexOf(TARGETS[i].prefix) === 0) return TARGETS[i];
    }
    return null;
  }

  function makeAccordion(target, headingEl) {
    var wrap = document.createElement('div');
    wrap.className = 'product__accordion accordion quick-add-hidden sgx-desc-accordion';

    var details = document.createElement('details');

    var summary = document.createElement('summary');
    var stitle = document.createElement('div');
    stitle.className = 'summary__title';

    var icon = document.createElement('span');
    icon.className = 'svg-wrapper';
    icon.innerHTML = target.icon;

    var h = document.createElement('h2');
    h.className = 'h4 accordion__title inline-richtext';
    h.textContent = (headingEl.textContent || '').trim();

    stitle.appendChild(icon);
    stitle.appendChild(h);
    summary.appendChild(stitle);
    summary.insertAdjacentHTML('beforeend', CARET);

    var body = document.createElement('div');
    body.className = 'accordion__content rte';

    details.appendChild(summary);
    details.appendChild(body);
    wrap.appendChild(details);

    return { wrap: wrap, body: body };
  }

  function isBoundary(el) {
    if (isHeading(el)) return true;
    if (el.classList &&
        (el.classList.contains('product-usage-advice') ||
         el.classList.contains('sgx-desc-accordion'))) return true;
    return false;
  }

  function process(container) {
    if (!container || container.getAttribute('data-sgx-acc') === '1') return;
    var kids = Array.prototype.slice.call(container.children);
    var did = false;

    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      var target = matchTarget(el);
      if (!target) continue;

      var acc = makeAccordion(target, el);
      container.insertBefore(acc.wrap, el);

      /* déplace le contenu qui suit le titre jusqu'au prochain titre / bloc frontière */
      var sib = el.nextElementSibling;
      while (sib && !isBoundary(sib)) {
        var next = sib.nextElementSibling;
        acc.body.appendChild(sib);
        sib = next;
      }

      if (el.parentNode) el.parentNode.removeChild(el);
      did = true;
    }

    if (did) container.setAttribute('data-sgx-acc', '1');
  }

  function injectStyle() {
    if (document.getElementById('sgx-desc-acc-style')) return;
    var s = document.createElement('style');
    s.id = 'sgx-desc-acc-style';
    s.textContent =
      'product-info .product__description .sgx-desc-accordion{margin-top:10px!important;border:1px solid var(--line,#ece4d4)!important;border-radius:var(--r-sm,12px)!important;overflow:hidden;}' +
      'product-info .product__description .sgx-desc-accordion:first-child{margin-top:16px!important;}';
    document.head.appendChild(s);
  }

  function run() {
    injectStyle();
    var list = document.querySelectorAll('.product__description');
    for (var i = 0; i < list.length; i++) process(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* Éditeur de thème */
  document.addEventListener('shopify:section:load', run);
})();
